import { AlertCircle, RefreshCw } from "lucide-react"
import { useSyncSubscriptions } from "@/entities/subscription"
import { Button } from "@/shared/ui/button"

interface NoSubscriptionsScreenProps {
	onRetry?: () => void
}

export function NoSubscriptionsScreen({ onRetry }: NoSubscriptionsScreenProps) {
	const syncSubscriptions = useSyncSubscriptions()

	const handleSync = async () => {
		try {
			const result = await syncSubscriptions.mutateAsync()
			if (result.hasSubscriptions) {
				onRetry?.()
			}
		} catch (error) {
			console.error("Failed to sync subscriptions:", error)
		}
	}

	return (
		<div className="flex flex-col items-center justify-center min-h-screen p-6 bg-gradient-to-b from-background to-muted/20">
			<div className="max-w-md w-full space-y-6">
				<div className="flex justify-center">
					<div className="relative">
						<div className="w-24 h-24 bg-primary/10 rounded-full flex items-center justify-center">
							<AlertCircle className="w-12 h-12 text-primary" />
						</div>
					</div>
				</div>

				<div className="text-center space-y-2">
					<h1 className="text-2xl font-bold tracking-tight">Доступ закрыт</h1>
					<p className="text-muted-foreground">Этот контент доступен только участникам КМК</p>
				</div>

				<div className="border border-primary/20 rounded-lg p-4 bg-primary/5">
					<div className="flex gap-3">
						<AlertCircle className="h-5 w-5 text-primary flex-shrink-0 mt-0.5" />
						<div className="space-y-2">
							<h3 className="font-semibold">Как получить доступ?</h3>
							<ol className="list-decimal list-inside space-y-1 text-sm text-muted-foreground">
								<li>Подпишитесь на канал КМК</li>
								<li>Вернитесь в приложение</li>
								<li>Нажмите кнопку "Проверить подписку"</li>
							</ol>
						</div>
					</div>
				</div>

				<div className="space-y-3">
					<Button
						onClick={handleSync}
						disabled={syncSubscriptions.isPending}
						className="w-full"
						size="lg"
					>
						{syncSubscriptions.isPending ? (
							<>
								<RefreshCw className="mr-2 h-4 w-4 animate-spin" />
								Проверяем...
							</>
						) : (
							<>
								<RefreshCw className="mr-2 h-4 w-4" />
								Проверить подписку
							</>
						)}
					</Button>

					{syncSubscriptions.isError && (
						<p className="text-sm text-destructive text-center">
							Ошибка при проверке подписок. Попробуйте ещё раз.
						</p>
					)}
				</div>

				<div className="text-center">
					<p className="text-xs text-muted-foreground">
						Если вы уже подписаны на КМК, нажмите кнопку выше
					</p>
				</div>
			</div>
		</div>
	)
}
